import React, { useState, useEffect } from "react";
import "./AddStudyMaterial.css";
import axios from "../../../../axios";
import AddStudyMaterialToolTip from "./AddStudyMaterialToolTip";
import { useNavigate } from "react-router-dom";
import AssessmentTypePopUP from "../../../../Assesment/pages/On_going/Published_Assessment/AssessmentTypePopUP";
import LinkedLecturePopup from "../SubjectDatailsCM/PopUp/LinkedLecturePopup";
import { toast } from "react-toastify";
import ConfirmationPopup from "./ConfirmationPopup";
import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import {
  fullAsessment,
  hasActivity,
  hasHW,
  hasPreRead,
} from "../../../../Utils/features";
import { Lock } from "@mui/icons-material";
export default function AddStudyMaterial({
  setClick,
  data,
  standardId,
  sectionId,
  supplementId,
  redirectState,
  seletedType,
  supplementDataHandle,
  setReRenderPage,
  supplement,
}) {
  const [displayDetails, setDisplayDetails] = useState([]);
  const [buttonfunction, setButtonFunction] = useState("");
  const [filterText, setFilterText] = useState();
  const [isAssessmentTypePopUp, setIsAssessmentTypePopUp] = useState(false);
  const [assDefaultRouteData, setAssDefaultRouteData] = useState(false);
  const [clickOpenUp, setClickOpenUp] = useState(false);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [isLoadingSupplements, setIsLoadingSupplements] = useState(false);
  let TeacherId = JSON.parse(localStorage.getItem("Teacher_id"));
  const iconHandle = (index) => {
    if (buttonfunction === "Assessment") {
      return assessmentClickedIndex === index
        ? "/ContentM_images/AssessmentClicked.svg"
        : "/ContentM_images/assessment_cm.svg";
    }
    if (buttonfunction === "preRead") {
      return preReadClickedIndex === index
        ? "/ContentM_images/preread_orange.svg"
        : "/ContentM_images/preread_cm.svg"; // Set the appropriate image URLs here
    }
    if (buttonfunction === "Homework") {
      return homeworkClickedIndex === index
        ? "/ContentM_images/homework_orange.svg"
        : "/ContentM_images/homework_cm.svg"; // Set the appropriate image URLs here
    }
    if (buttonfunction === "Activity") {
      return activityClickedIndex === index
        ? "/ContentM_images/activity_orange.svg"
        : "/ContentM_images/activity_cm.svg"; // Set the appropriate image URLs here
    }
  };
  const [assessmentSelect, setAssessmentSelect] = useState([]);
  const [preReadSelect, setPreReadSelect] = useState([]);
  const [homeworkSelect, setHomeworkSelect] = useState([]);
  const [activitySelect, setActivitySelect] = useState([]);
  const [assessmentClickedIndex, setAssessmentClickedIndex] = useState(-1);
  const [preReadClickedIndex, setPreReadClickedIndex] = useState(-1);
  const [homeworkClickedIndex, setHomeworkClickedIndex] = useState(-1);
  const [activityClickedIndex, setActivityClickedIndex] = useState(-1);
  const navigate = useNavigate();
  const [supleeCreated, setSupleeCreated] = useState(null);
  const [foundLinkedLecuter, setFoundLinkedLecture] = useState("");
  const [isPastLecture, setIsPastLecture] = useState(false);
  const [unSavedDialog, setUnSavedDialog] = useState(false);

  const [savedLocalData, setSavedLocalData] = useState(null);

  const handleSupplementClick = (data, index) => {
    if (buttonfunction === "Assessment") {
      setAssessmentClickedIndex(index);
      setFoundLinkedLecture(data);
      if (assessmentSelect.length < 1 || !assessmentSelect.includes(data.id)) {
        setAssessmentSelect([data.id]);
      } else {
        const updatedSelection = assessmentSelect.filter(
          (id) => id !== data.id,
        );
        setAssessmentSelect(updatedSelection);
      }
      if (index === assessmentClickedIndex) {
        setAssessmentClickedIndex(-1);
      } else {
        setAssessmentClickedIndex(index);
      }
    }
    if (buttonfunction === "preRead") {
      setPreReadClickedIndex(index);
      setFoundLinkedLecture(data);
      if (preReadSelect.length < 1 || !preReadSelect.includes(data.id)) {
        setPreReadSelect([data.id]);
      } else {
        const updatedSelection = preReadSelect.filter((id) => id !== data.id);
        setPreReadSelect(updatedSelection);
      }
      if (index === preReadClickedIndex) {
        setPreReadClickedIndex(-1);
      } else {
        setPreReadClickedIndex(index);
      }
    }
    if (buttonfunction === "Homework") {
      setHomeworkClickedIndex(index);
      setFoundLinkedLecture(data);
      if (homeworkSelect.length < 1 || !homeworkSelect.includes(data.id)) {
        setHomeworkSelect([data.id]);
      } else {
        const updatedSelection = homeworkSelect.filter((id) => id !== data.id);
        setHomeworkSelect(updatedSelection);
      }

      if (index === homeworkClickedIndex) {
        setHomeworkClickedIndex(-1);
      } else {
        setHomeworkClickedIndex(index);
      }
    }

    if (buttonfunction === "Activity") {
      setActivityClickedIndex(index);
      setFoundLinkedLecture(data);
      if (activitySelect.length < 1 || !activitySelect.includes(data.id)) {
        setActivitySelect([data.id]);
      } else {
        const updatedSelection = activitySelect.filter((id) => id !== data.id);
        setActivitySelect(updatedSelection);
      }

      if (index === activityClickedIndex) {
        setActivityClickedIndex(-1);
      } else {
        setActivityClickedIndex(index);
      }
    }
  };

  // useEffect(() => {
  //   if (buttonfunction === "Assessment") {
  //     setDisplayDetails([]);
  //     if (!filterText) {
  //       axios
  //         .get(
  //           `/api/v1/assessment/filterByTeacherId/${TeacherId}/scheduled?sortBy=-1&_page=1&_limit=100&&&&&&false&subjectId=${
  //             data?.subject?.id ?? data.Subject_id
  //           }`
  //         )
  //         .then((res) => {
  //           setDisplayDetails(res.data.data);
  //         });
  //     } else {
  //       setDisplayDetails([]);
  //       axios
  //         .get(
  //           `/api/v1/assessment/filterByTeacherId/${TeacherId}/scheduled?sortBy=-1&_page=1&_limit=100&&name=${filterText}&&&&false&subjectId=${
  //             data?.subject?.id ?? data.Subject_id
  //           }`
  //         )
  //         .then((res) => {
  //           setDisplayDetails(res.data.data);
  //           // console.log(displayDetails);
  //         });
  //     }
  //   }
  //   if (buttonfunction === "Homework") {
  //     setDisplayDetails([]);
  //     if (!filterText) {
  //       axios
  //         .get(
  //           `/api/v1/homework/filterByTeacherId/${TeacherId}/published?sortBy=-1&_page=1&_limit=100&&&&&&false&subjectId=${
  //             data?.subject?.id ?? data.Subject_id
  //           }`
  //         )
  //         .then((res) => {
  //           setDisplayDetails(res.data.data);
  //         });
  //     } else {
  //       setDisplayDetails([]);
  //       // axios.get(`/api/v1/homework/filterByTeacherId/${TeacherId}/published?sortBy=-1&_page=1&_limit=4&name=${filterText}`).then((res) => {
  //       axios
  //         .get(
  //           `/api/v1/homework/filterByTeacherId/${TeacherId}/published?_page=1&&name=${filterText}&&&&false&subjectId=${
  //             data?.subject?.id ?? data.Subject_id
  //           }`
  //         )
  //         .then((res) => {
  //           setDisplayDetails(res.data.data);
  //         });
  //     }
  //   }
  //   if (buttonfunction === "preRead") {
  //     setDisplayDetails([]);
  //     if (!filterText) {
  //       axios
  //         .get(
  //           `/api/v1/homework/preRead/filterByTeacherId/${TeacherId}/published?sortBy=-1&_page=1&_limit=100&&&&&&false&subjectId=${
  //             data?.subject?.id ?? data.Subject_id
  //           }`
  //         )
  //         .then((res) => {
  //           setDisplayDetails(res.data.data);
  //         });
  //     } else {
  //       setDisplayDetails([]);
  //       axios
  //         .get(
  //           `/api/v1/homework/preRead/filterByTeacherId/${TeacherId}/published?_page=1&&name=${filterText}&&&&false&subjectId=${
  //             data?.subject?.id ?? data.Subject_id
  //           }`
  //         )
  //         .then((res) => {
  //           setDisplayDetails(res.data.data);
  //         });
  //     }
  //   }
  //   if (buttonfunction === "Activity") {
  //     if (!filterText) {
  //       setDisplayDetails([]);
  //       axios
  //         .get(
  //           `/api/v1/homework/activity/filterByTeacherId/${TeacherId}/published?sortBy=-1&_page=1&_limit=100&&&&&&false&subjectId=${
  //             data?.subject?.id ?? data.Subject_id
  //           }`
  //         )
  //         .then((res) => {
  //           setDisplayDetails(res.data.data);
  //         });
  //     } else {
  //       setDisplayDetails([]);
  //       // axios.get(`/api/v1/homework/activity/filterByTeacherId/${TeacherId}/published?sortBy=-1&_page=1&_limit=4&name=${filterText}`).then((res) => {
  //       axios
  //         .get(
  //           `/api/v1/homework/activity/filterByTeacherId/${TeacherId}/published?&&&name=${filterText}&&&false&subjectId=${
  //             data?.subject?.id ?? data.Subject_id
  //           }`
  //         )
  //         .then((res) => {
  //           setDisplayDetails(res.data.data);
  //         });
  //     }
  //   }
  // }, [buttonfunction, filterText]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoadingSupplements(true);
        setDisplayDetails([]);

        const subjectId = data?.subject?.id ?? data?.Subject_id;

        let baseUrl = "";

        switch (buttonfunction) {
          case "Assessment":
            baseUrl = `/api/v1/assessment/filterByTeacherId/${TeacherId}/scheduled`;
            break;

          case "Homework":
            baseUrl = `/api/v1/homework/filterByTeacherId/${TeacherId}/published`;
            break;

          case "preRead":
            baseUrl = `/api/v1/homework/preRead/filterByTeacherId/${TeacherId}/published`;
            break;

          case "Activity":
            baseUrl = `/api/v1/homework/activity/filterByTeacherId/${TeacherId}/published`;
            break;

          default:
            return;
        }

        const url = `${baseUrl}?sortBy=-1&_page=1&_limit=100${
          filterText ? `&name=${filterText}` : ""
        }&subjectId=${subjectId}`;

        const res = await axios.get(url);

        setDisplayDetails(res?.data?.data || []);
      } catch (error) {
        console.log("API Error:", error);
        setDisplayDetails([]);
      } finally {
        setIsLoadingSupplements(false);
      }
    };

    fetchData();
  }, [buttonfunction, filterText, data]);
  useEffect(() => {
    if (seletedType) {
      setButtonFunction(seletedType);
    }
  }, []);

  let defaultRouteData = {
    standardId: standardId,
    sectionId: sectionId,
    subjectId: data?.subject?.id ?? data?.Subject_id,
    defaultData: true,
    fromLiveSession: "liveSession",
    supplement_id: supplementId,
    redirectStateData: {
      ...redirectState,
      buttonfunction: buttonfunction,
      addMaterial: true,
    },
  };

  const selectedBox = localStorage.getItem("selectedBox");

  const handleCreateClick = () => {
    if (buttonfunction === "Assessment") {
      localStorage.setItem("Header", "Content Management (Assessment)");

      const savedAssessmentData = JSON.parse(
        localStorage.getItem("temp_Questions_ASSESSMENT"),
      );

      if (savedAssessmentData) {
        setUnSavedDialog(true);
        setSavedLocalData(savedAssessmentData.assessmentDetails);
      } else {
        setIsAssessmentTypePopUp(true);
        setAssDefaultRouteData(defaultRouteData);
      }
    }
    if (buttonfunction === "preRead") {
      localStorage.setItem("Header", "Content Management (Pre-read)");

      const savedPreReadDAta = JSON.parse(
        localStorage.getItem("prereadStateLocal"),
      );
      if (savedPreReadDAta) {
        setUnSavedDialog(true);
        setSavedLocalData(savedPreReadDAta);
      } else {
        navigate("/createPreRead", { state: defaultRouteData });
      }
    }
    if (buttonfunction === "Homework") {
      localStorage.setItem("Header", "Content Management (Homework)");

      const savedHomeworkDAta = JSON.parse(
        localStorage.getItem("temp_Questions_HOMEWORK"),
      );

      if (savedHomeworkDAta) {
        setUnSavedDialog(true);
        setSavedLocalData(savedHomeworkDAta?.HomeWorkDetails);
        navigate("/CreateHomework");
      } else {
        navigate("/CreateHomework", { state: defaultRouteData });
      }
    }
    if (buttonfunction === "Activity") {
      localStorage.setItem("Header", "Content Management (Activity)");
      const SavedActivityData = JSON.parse(
        localStorage.getItem("ActivityLocalStorageData"),
      );
      if (SavedActivityData) {
        setUnSavedDialog(true);
        setSavedLocalData(SavedActivityData);
      } else {
        navigate("/CreateActivity", { state: defaultRouteData });
      }
    }
  };
  function formatDate(inputDate) {
    const date = new Date(inputDate);

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");

    return `${year}-${month}-${day}`;
  }
  let fromDCM = localStorage.getItem("from");
  const handleAddToSession = async () => {
    let body = {
      preRead: preReadSelect[0],
      activity: activitySelect[0],
      assessment: assessmentSelect[0],
      homework: homeworkSelect[0],
    };
    try {
      let res = await axios.post(
        `/api/v1/cm/liveSession/addSupplements?lecture_id=${
          data?.id || data?.Id
        }&schedule_date=${data?.date || formatDate(data?.StartTime)}`,
        body,
      );
      if (res) {
        let id = res?.data?.data?.id;
        let supplements = res?.data?.data?.supplements;
        if (supplementId === undefined) {
          // Check if `supplements` is a valid array
          if (Array.isArray(supplements) && supplements.length > 0) {
            let length = supplements.length;
            let ids = supplements[length - 1]; // Get the last item
            navigate("/liveSession", {
              state: {
                supplement_id: ids,
                standard_id: standardId,
                section_id: sectionId,
                lecture_id: data.id || data.Id,
                scheduled_date: data.date || formatDate(data.StartTime),
                sectionName: redirectState?.sectionName,
                standardsName: redirectState?.standardsName,
              },
              replace: true,
            });
          } else {
            navigate("/liveSession", {
              state: {
                supplement_id: id,
                standard_id: standardId,
                section_id: sectionId,
                lecture_id: data.id || data.Id,
                scheduled_date: data.date || formatDate(data.StartTime),
                sectionName: redirectState?.sectionName,
                standardsName: redirectState?.standardsName,
              },
              replace: true,
            });
          }
        } else {
          if (Array.isArray(supplements) && supplements.length > 0) {
            let length = supplements.length;
            let ids = supplements[length - 1]; // Get the last item
            navigate("/liveSession", {
              state: {
                supplement_id: ids,
                standard_id: standardId,
                section_id: sectionId,
                lecture_id: data.id || data.Id,
                scheduled_date: data.date || formatDate(data.StartTime),
                sectionName: redirectState?.sectionName,
                standardsName: redirectState?.standardsName,
              },
              replace: true,
            });
          } else {
            navigate("/liveSession", {
              state: {
                supplement_id: id,
                standard_id: standardId,
                section_id: sectionId,
                lecture_id: data.id || data.Id,
                scheduled_date: data.date || formatDate(data.StartTime),
                sectionName: redirectState?.sectionName,
                standardsName: redirectState?.standardsName,
              },
              replace: true,
            });
          }
          // navigate("/liveSession", {
          //   state: {
          //     supplement_id: supplementId || id,
          //     standard_id: standardId,
          //     section_id: sectionId,
          //     lecture_id: data.id || data.Id,
          //     scheduled_date: data.date || formatDate(data.StartTime),
          //     sectionName: redirectState?.sectionName,
          //     standardsName: redirectState?.standardsName
          //   },
          //   replace: true
          // });
        }
      }
      // if (res.status === 200) {
      //   if (fromDCM === "DCM") {
      //     // console.log("from dsm : ", res)
      //     // navigate("/DcmTimeTable")

      //   } else {
      //     // if (supplementId === undefined) {
      //     //   console.log("inside if : ", supplementId)
      //     //   let id = res?.data?.data?.id;
      //     //   let length = res?.data?.data?.supplements.length;
      //     //   let ids = res?.data?.data?.supplements[length - 1];
      //     //   console.log("ids", ids)
      //     //   console.log("res?.data?.data?.id", res?.data?.data?.id)
      //     //   console.log("id---->", id)

      //     //   console.log("length", length)

      //     //   navigate("/liveSession", { state: { supplement_id: ids || id, standard_id: standardId, section_id: sectionId, lecture_id: data.id || data.Id, scheduled_date: data.date || formatDate(data.StartTime) }, replace: true })
      //     // } else {
      //     //   console.log("afte  if : ", data)
      //     //   navigate("/liveSession", { state: { supplement_id: supplementId, standard_id: standardId, section_id: sectionId, lecture_id: data.id || data.Id, scheduled_date: data.date || formatDate(data.StartTime) }, replace: true })
      //     // }

      //   }
      // }

      supplementDataHandle();
      toast.success("Supplement Added Successfully!!");
      setClick((prev) => {
        return {
          ...prev,
          addMaterial: false,
        };
      });
    } catch (err) {
      console.log(err);
    } finally {
      setReRenderPage(true);
    }
  };

  const buttonDisabled = () => {
    if (
      assessmentSelect.length !== 0 ||
      !preReadSelect.length !== 0 ||
      homeworkSelect.length !== 0 ||
      activitySelect.length !== 0
    ) {
      return false;
    } else {
      return true;
    }
  };

  const handleAddToSessionButton = () => {
    if (buttonDisabled()) return;

    // supplement undefined/null hai → directly session start
    if (!supplement) {
      handleAddToSession();
      return;
    }

    // Supplement defined → check type
    switch (buttonfunction) {
      case "Assessment":
        if (supplement.assessment) {
          setShowConfirmPopup(true);
        } else {
          handleAddToSession();
        }
        break;

      case "preRead":
        if (supplement.preRead) {
          setShowConfirmPopup(true);
        } else {
          handleAddToSession();
        }
        break;

      case "Homework":
        if (supplement.homework) {
          setShowConfirmPopup(true);
        } else {
          handleAddToSession();
        }
        break;

      case "Activity":
        if (supplement.activity) {
          setShowConfirmPopup(true);
        } else {
          handleAddToSession();
        }
        break;

      default:
        handleAddToSession();
    }
  };

  const checkDisable = () => {
    const hasData =
      assessmentSelect.length > 0 ||
      preReadSelect.length > 0 ||
      homeworkSelect.length > 0 ||
      activitySelect.length > 0;
    if (hasData) {
      return true;
    } else {
      return false;
    }
  };

  const handleAddToSessionLinkedLecture = () => {
    if (
      foundLinkedLecuter?.add_to_live_session &&
      Object.keys(foundLinkedLecuter.add_to_live_session).length > 0 &&
      foundLinkedLecuter.add_to_live_session.lecture_id != null
    ) {
      setClickOpenUp(true);
    } else {
      handleAddToSessionButton();
      if (isPastLecture) {
        setClick({ addMaterial: true });
      } else {
        setClick({ addMaterial: false });
      }
    }
  };

  useEffect(() => {
    const handleNotAllowAddSupplementPastLecture = () => {
      const lectureEndDateStr = data?.EndTime;
      if (!lectureEndDateStr) return;

      const lectureEndDate = new Date(lectureEndDateStr);
      const now = new Date();

      if (now > lectureEndDate) {
        setIsPastLecture(true);
      } else {
        setIsPastLecture(false);
      }
    };

    handleNotAllowAddSupplementPastLecture();
  }, [data]);

  const handleContinueSaved = () => {
    setUnSavedDialog(false);
    if (buttonfunction === "preRead") {
      localStorage.setItem("Header", "Content Management (Pre-read)");
      navigate("/createPreRead");
    }
    if (buttonfunction === "Homework") {
      localStorage.setItem("Header", "Content Management (Homework)");
      navigate("/createHomework");
    }
    if (buttonfunction === "Activity") {
      localStorage.setItem("Header", "Content Management (Activity)");
      navigate("/createActivity");
    }
    if (buttonfunction === "Assessment") {
      localStorage.setItem("Header", "Content Management (Assessment)");
      navigate("/create", {
        state: {
          selectedBox: selectedBox,
        },
      });
    }
  };

  const handleCreateNew = () => {
    if (buttonfunction === "preRead") {
      localStorage.removeItem("prereadStateLocal");
      localStorage.setItem("Header", "Content Management (Pre-read)");
      navigate("/createPreRead", { state: defaultRouteData });
    }
    if (buttonfunction === "Homework") {
      localStorage.removeItem("temp_Questions_HOMEWORK");
      localStorage.removeItem("currentStepHW");
      localStorage.setItem("Header", "Content Management (Homework)");
      navigate("/CreateHomework", { state: defaultRouteData });
    }
    if (buttonfunction === "Activity") {
      localStorage.removeItem("ActivityLocalStorageData");
      localStorage.setItem("Header", "Content Management (Activity)");
      navigate("/CreateActivity", { state: defaultRouteData });
    }
    if (buttonfunction === "Assessment") {
      localStorage.removeItem("temp_Questions_ASSESSMENT");
      localStorage.removeItem("currentStep");
      localStorage.setItem("Header", "Content Management (Assessment)");
      setUnSavedDialog(false);
      setIsAssessmentTypePopUp(true);
      setAssDefaultRouteData(defaultRouteData);
    }
  };

  const isFeatureAvailable =
    hasHW || hasPreRead || hasActivity || fullAsessment;

  return (
    <div className="StudyMaterial_container">
      <div className="StudyMaterial_Subcontainer p-4">
        <div className="d-flex justify-content-between flex-wrap">
          {/* Here rename the text */}
          <p className="addMaterial_title">Add Lecture Supplement</p>

          <Button
            variant="contained"
            disabled={!isFeatureAvailable || !buttonfunction}
            onClick={() => {
              if (isPastLecture) {
                toast.error("Lecture Session already completed!!");
                setClick({ addMaterial: true });
              } else {
                handleCreateClick();
              }
            }}
            startIcon={
              <img
                src="/ContentM_images/add icon.svg"
                alt="add logo"
                style={{ width: 16, height: 16 }}
              />
            }
            sx={{
              backgroundColor: "#f97316", // orange
              color: "#ffffff",
              textTransform: "none",
              fontWeight: 500,
              "&:hover": {
                backgroundColor: "#ea580c", // darker orange
              },
              "&.Mui-disabled": {
                backgroundColor: "#fdba74",
                color: "#fff",
                opacity: 0.6,
              },
            }}
          >
            Create
          </Button>
        </div>
        {isFeatureAvailable ? (
          <>
            <div className="gap-3 d-flex flex-wrap mt-1">
              {fullAsessment && (
                <button
                  className={
                    buttonfunction === "Assessment"
                      ? "four_material_typeClicked"
                      : "four_material_type"
                  }
                  onClick={() => {
                    setButtonFunction("Assessment");
                  }}
                >
                  Assessment
                </button>
              )}

              {hasPreRead && (
                <button
                  className={
                    buttonfunction === "preRead"
                      ? "four_material_typeClicked"
                      : "four_material_type"
                  }
                  onClick={() => {
                    setButtonFunction("preRead");
                  }}
                >
                  Pre-read
                </button>
              )}
              {hasActivity && (
                <button
                  className={
                    buttonfunction === "Activity"
                      ? "four_material_typeClicked"
                      : "four_material_type"
                  }
                  onClick={() => {
                    setButtonFunction("Activity");
                  }}
                >
                  Activity
                </button>
              )}
              {hasHW && (
                <button
                  className={
                    buttonfunction === "Homework"
                      ? "four_material_typeClicked"
                      : "four_material_type"
                  }
                  onClick={() => {
                    setButtonFunction("Homework");
                  }}
                >
                  Homework
                </button>
              )}
            </div>
            <div className="mt-3">
              <input
                type="search"
                placeholder="Search"
                className="col-12 search_Addmaterial"
                onChange={(e) => {
                  setFilterText(e.target.value);
                }}
              />
            </div>
            <div className="recent_content mt-2">Recent Lecture Supplement</div>
            <div className="ContentStyl">
              {/* 1️⃣ Button not selected */}
              {!buttonfunction ? (
                <div className="d-flex justify-content-center mt-3">
                  <Card
                    sx={{ maxWidth: 360, textAlign: "center", boxShadow: 2 }}
                  >
                    <CardContent>
                      <Typography fontWeight={600}>
                        Select a Supplement Type
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Please select a supplement type to continue.
                      </Typography>
                    </CardContent>
                  </Card>
                </div>
              ) : isLoadingSupplements ? (
                /* 2️⃣ Loading state */
                <div className="d-flex justify-content-center mt-4">
                  <Typography variant="body2" color="text.secondary">
                    Loading supplements...
                  </Typography>
                </div>
              ) : displayDetails.length > 0 ? (
                /* 3️⃣ Data available */
                displayDetails.map((obj, index) => (
                  <AddStudyMaterialToolTip
                    key={index}
                    name={obj.name}
                    description={obj.description}
                    scheduledDate={obj.deadline}
                  >
                    <div
                      className={`d-flex gap-2 align-items-center ${
                        (buttonfunction === "Assessment" &&
                          assessmentClickedIndex === index) ||
                        (buttonfunction === "preRead" &&
                          preReadClickedIndex === index) ||
                        (buttonfunction === "Activity" &&
                          activityClickedIndex === index) ||
                        (buttonfunction === "Homework" &&
                          homeworkClickedIndex === index)
                          ? "totalDetail_recentClicked"
                          : "totalDetail_recent"
                      }`}
                      onClick={() => handleSupplementClick(obj, index)}
                    >
                      <img
                        className="cm_actitity_icon"
                        src={iconHandle(index)}
                        alt="icon"
                      />
                      <div>{obj.name}</div>
                    </div>
                  </AddStudyMaterialToolTip>
                ))
              ) : (
                /* 4️⃣ No data AFTER loading finished */
                <div className="d-flex justify-content-center mt-3">
                  <Card
                    sx={{ maxWidth: 360, textAlign: "center", boxShadow: 2 }}
                  >
                    <CardContent>
                      <Typography fontWeight={600}>
                        No Supplements Found
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        There are no {buttonfunction} supplements available.
                      </Typography>
                    </CardContent>
                  </Card>
                </div>
              )}
            </div>

            <div className="d-flex gap-3 align-items-center justify-content-end mt-4">
              <span className="recent_content">
                Selected (
                {assessmentSelect.length +
                  preReadSelect.length +
                  activitySelect.length +
                  homeworkSelect.length}
                )
              </span>
              <button
                onClick={() => {
                  handleAddToSessionLinkedLecture();
                }}
                className={
                  !checkDisable()
                    ? "addToSessionBtnDisable"
                    : "addToSessionBtn "
                }
              >
                Add to Session
              </button>
            </div>
          </>
        ) : (
          <div className="d-flex justify-content-center align-items-center mt-4">
            <Card
              sx={{
                maxWidth: 420,
                width: "100%",
                borderRadius: 2,
                boxShadow: 3,
                textAlign: "center",
              }}
            >
              <CardContent className="d-flex flex-column align-items-center gap-2">
                <Lock size={32} className="text-muted" />

                <Typography variant="h6" fontWeight={600}>
                  No Supplements Available
                </Typography>

                <Typography variant="body2" color="text.secondary">
                  Supplement features are not enabled for this lecture. Please
                  enable them to add Assessment, Pre-read, Activity or Homework.
                </Typography>
              </CardContent>
            </Card>
          </div>
        )}
      </div>

      <div className="CrossContainer_CM CrossContainer_CM1">
        <img
          onClick={(e) => {
            setClick({ addMaterial: false });
          }}
          src="/ContentM_images/cross_icon_cm.svg"
          alt="cross logo"
          className="cross-icon"
        />
      </div>
      {isAssessmentTypePopUp && (
        <AssessmentTypePopUP
          setIsAssessmentTypePopUp={setIsAssessmentTypePopUp}
          assDefaultRouteData={assDefaultRouteData}
        />
      )}
      {clickOpenUp && (
        <LinkedLecturePopup
          setClickOpenUp={setClickOpenUp}
          handleAddToSessionButton={handleAddToSessionButton}
          setClick={setClick}
          isPastLecture={isPastLecture}
        />
      )}
      {showConfirmPopup && (
        <ConfirmationPopup
          setShowConfirmPopup={setShowConfirmPopup}
          handleAddToSession={handleAddToSession}
        />
      )}

      <Dialog open={unSavedDialog} onClose={() => setUnSavedDialog(false)}>
        <DialogTitle>Unsaved Changes Found</DialogTitle>
        <DialogContent>
          <Typography>
            You already have an unsaved Changes –{" "}
            <Typography
              component="span"
              sx={{
                fontWeight: "bold",
                color: "error.main",
                textDecoration: "underline",
              }}
            >
              {savedLocalData?.tittle || savedLocalData?.name}
            </Typography>
            . Do you want to Restore?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setUnSavedDialog(false)}
            color="primary"
            variant="contained"
          >
            Cancel
          </Button>
          <Button
            onClick={handleContinueSaved}
            color="primary"
            variant="outlined"
          >
            Continue
          </Button>
          <Button onClick={handleCreateNew} color="error" variant="contained">
            Ignore
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
